<script setup lang="ts">
  import type { HTMLAttributes } from 'vue'
  import { inject } from 'vue'
  import { cn } from '../../../lib/utils'
  import { FIELD_CONTEXT_KEY } from '../field'

  const props = defineProps<{
    class?: HTMLAttributes['class']
  }>()

  const context = inject(FIELD_CONTEXT_KEY, { variant: 'default' as const })

  const focusClasses =
    'has-[[data-slot=input-group-control]:focus-visible]:z-10 has-[[data-slot=input-group-control]:focus-visible]:border-ring has-[[data-slot=input-group-control]:focus-visible]:ring-ring/50 has-[[data-slot=input-group-control]:focus-visible]:ring-[3px]'

  const errorClasses =
    'has-[[data-slot][aria-invalid=true]]:ring-destructive/20 has-[[data-slot][aria-invalid=true]]:border-destructive dark:has-[[data-slot][aria-invalid=true]]:ring-destructive/40'
</script>

<template>
  <!-- Stacked -->
  <div
    v-if="context.variant === 'stacked'"
    data-slot="input-group"
    role="group"
    :class="
      cn(
        'group/input-group bg-card border-input dark:bg-input/30 relative flex w-full items-center rounded-md border outline-none transition-[color,box-shadow]',
        'min-w-0 has-[>textarea]:h-auto',
        'has-[>[data-align=block-start]]:flex-col',
        'has-[>[data-align=block-end]]:flex-col',
        focusClasses,
        errorClasses,
        props.class
      )
    "
  >
    <slot />
  </div>

  <!-- Default -->
  <div
    v-else
    data-slot="input-group"
    role="group"
    :class="
      cn(
        'group/input-group border-input dark:bg-input/30 shadow-xs relative flex w-full items-center rounded-md border outline-none transition-[color,box-shadow]',
        'h-9 min-w-0 has-[>textarea]:h-auto',
        'has-[>[data-align=inline-start]]:[&>input]:pl-2',
        'has-[>[data-align=inline-end]]:[&>input]:pr-2',
        'has-[>[data-align=block-start]]:h-auto has-[>[data-align=block-start]]:flex-col has-[>[data-align=block-start]]:[&>input]:pb-3',
        'has-[>[data-align=block-end]]:h-auto has-[>[data-align=block-end]]:flex-col has-[>[data-align=block-end]]:[&>input]:pt-3',
        focusClasses,
        errorClasses,
        props.class
      )
    "
  >
    <slot />
  </div>
</template>
